export enum ContentFeedbackStatus {
  Idle = "idle",
  Submitting = "submitting",
  JustSubmitted = "justSubmitted",
  Submitted = "submitted",
  LimitReached = "limitReached",
  JustLimitReached = "justLimitReached",
  Error = "error",
}
